import product1 from '../../images/product-1.jpg';
import product2 from '../../images/product-2.jpg';
import product3 from '../../images/product-3.jpg';
import sweet1 from '../../images/sweet-1.jpeg';
import sweet2 from '../../images/sweet-2.jpeg';
import sweet3 from '../../images/sweet-3.jpg';


export const productData = [
  {
    img: product1,
    alt: 'Pizza',
    name: 'Chicken Supreme',
    desc:
      'Tomato sauce, chicken, capsicum, and pineapple',
    price: '$20.99',
    button: 'Add to Cart'
  },
  {
    img: product2,
    alt: 'Pizza',
    name: 'Hawaiian',
    desc:
      'Tomato sauce, ham, and pineapple',
    price: '$16.99',
    button: 'Add to Cart'
  },
  {
    img: product3,
    alt: 'Pizza',
    name: 'Ultimate Veggie',
    desc:
      'Tomato sauce, capsicum, mushroom, onion, and olives',
    price: '$15.99',
    button: 'Add to Cart'
  }
];

export const productDataTwo = [
  {
    img: sweet1,
    alt: 'tart',
    name: 'Amaretto tart',
    desc:
      'Garnished with toasted flaked almonds and drizzled with Melted dark chocolate',
    price: '$10.99',
    button: 'Add to Cart'
  },

  {
    img: sweet2,
    alt: 'Mangomisu',
    name: 'Mangomisu',
    desc:
      'Luxuriating with layers of freshly-diced mango, cheese , and vanilla cream ',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: sweet3,
    alt: 'Tiramisu',
    name: 'Tiramisu Crepes',
    desc:
      'Filled with creamy mascarpone cheese and laced with vanilla and a coffee liqueur',
    price: '$12.99',
    button: 'Add to Cart'
  },
  
];
